var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loader)?_c('div',{staticClass:"pag-loader"},[_c('v-progress-circular',{attrs:{"size":65,"width":6,"color":"#afafaf","indeterminate":"","id":"loading"}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }